import { CdkDrag } from '@angular/cdk/drag-drop';
import {
  ChangeDetectorRef,
  Component,
  effect,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  Renderer2,
  ViewChild
} from '@angular/core';
import {
  MarketDataService,
  Message
} from '@approot/monitoring/market-data/market-data.service';
import { AuthService } from '@approot/services';
import { parseJWT } from '@approot/utilities';
import { WindowIndexService } from '@approot/widgets/rfq/rfq-container/window-index.service';
import { Memoize } from 'lodash-decorators';

const WIN_POSITION_MIN_Y = 36;

@Component({
  selector: 'app-market-data',
  templateUrl: './market-data.component.html',
  styleUrls: ['./market-data.component.scss']
})
export class MarketDataComponent implements OnInit {
  @Input() public isModalOpened = true;
  public windowTop = 50;
  public windowLeft = 50;
  @ViewChild(CdkDrag) public dragEl: CdkDrag;
  @Output() public modalStateChanged = new EventEmitter<boolean>();
  public messages: Message[] = [];

  constructor(
    private renderer: Renderer2,
    private winIdx: WindowIndexService,
    private elementRef: ElementRef,
    public marketDataService: MarketDataService,
    private changeRef: ChangeDetectorRef,
    public authSvc: AuthService
  ) {
    effect(() => {
      const messages = this.marketDataService.messages();
      setTimeout(async () => {
        const cognito = await this.authSvc.currentSession();
        const jwt = parseJWT(cognito.getIdToken().getJwtToken());
        const group = jwt['cognito:groups']?.[0];
        // superusers will subscribe to all parents/groups (for the monitor page),
        // so we filter out just the current group on this page
        this.messages = messages
          .filter(m => m.name.toLocaleLowerCase() === group.toLocaleLowerCase())
          .sort((a, b) => {
            return a.label.localeCompare(b.label);
          });
        this.changeRef.markForCheck();
      }, 0);
    });
  }

  public ngOnInit() {
    this.updateZIndex();
    this.windowTop = 50 + Math.random() * (window.innerHeight / 8);
    this.windowLeft =
      window.innerWidth / 4 + Math.random() * (window.innerWidth / 4);
  }

  public updateZIndex() {
    this.winIdx.setWindowIndex(
      this.elementRef.nativeElement.querySelector('.market-data-drag'),
      this.renderer
    );
  }

  public dragEnd() {
    const el = (this.elementRef.nativeElement as HTMLElement).querySelector(
      '.market-data-drag'
    );
    const rect = el.getBoundingClientRect();

    let { x, y } = this.dragEl.getFreeDragPosition();

    if (rect.y < WIN_POSITION_MIN_Y) {
      y += WIN_POSITION_MIN_Y - rect.y;
    }
    this.dragEl.setFreeDragPosition({ x, y });
  }

  public close() {
    this.isModalOpened = false;
    this.modalStateChanged.emit(false);
  }

  @Memoize()
  public toMins(secs: number): number {
    return Math.round(secs / 60);
  }
}
